export default <T extends { [key: string]: any }>(object: T): [keyof T & string, T[keyof T]][] =>
	Object.entries(object)
